import https from "@/lib/https";
import type {
  ProjectDetail,
  ProjectPayload,
  GetProjectListParams,
} from "@/interface/profile";
import type { ApiResponse, PaginationResponse } from "@/interface/common";

const BASE_URL = "/api/projects/";

export const getProjectList = async (
  profileId: number | string,
  params?: GetProjectListParams,
): Promise<
  ApiResponse<PaginationResponse<ProjectDetail> | ProjectDetail[]>
> => {
  return await https.get<
    ApiResponse<PaginationResponse<ProjectDetail> | ProjectDetail[]>
  >(`/api/profiles/${profileId}/projects/`, params);
};

export const getProjectById = async (
  id: string | number,
): Promise<ApiResponse<ProjectDetail>> => {
  return await https.get<ApiResponse<ProjectDetail>>(`${BASE_URL}${id}/`);
};

export const createProject = async (
  payload: ProjectPayload,
): Promise<ApiResponse<ProjectDetail>> => {
  return await https.post<ApiResponse<ProjectDetail>>(BASE_URL, payload);
};

export const updateProject = async (
  id: string | number,
  payload: ProjectPayload,
): Promise<ApiResponse<ProjectDetail>> => {
  return await https.put<ApiResponse<ProjectDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const patchProject = async (
  id: string | number,
  payload: Partial<ProjectPayload>,
): Promise<ApiResponse<ProjectDetail>> => {
  return await https.patch<ApiResponse<ProjectDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const deleteProject = async (
  id: string | number,
): Promise<ApiResponse<void>> => {
  return await https.delete<ApiResponse<void>>(`${BASE_URL}${id}/`);
};
